import { FC } from 'react'
import cx from 'classnames'

import { PictureProps } from '../Picture'
import { LinkProps } from '../Link'
import { Icons } from '../Icon'
import { colors } from '../../theme'

import * as SC from './styled'

export type PortraitProps = {
  className?: string
  name?: string
  status?: string
  pictureProps: PictureProps
  linkProps?: LinkProps
  fullscreenOnMobile?: boolean
  color?: string
  role?: string
}

const Portrait: FC<PortraitProps> = ({
  className,
  name,
  status,
  pictureProps,
  linkProps,
  fullscreenOnMobile = true,
  color = colors.yellowPale,
  role,
}) => {
  return (
    <SC.Container
      className={cx('Portrait', className)}
      {...linkProps}
      {...(role ? { role } : {})}
    >
      <SC._Picture {...pictureProps} />
      <SC.Infos
        $largeOnMobile={fullscreenOnMobile}
        $color={color}
        {...(!status && !name ? { 'data-notext': true } : {})}
      >
        {name && <SC.Name>{name}</SC.Name>}
        {status && <SC.Status>{status}</SC.Status>}
        {linkProps?.href && <SC.Arrow icon={Icons.arrowRight} />}
      </SC.Infos>
    </SC.Container>
  )
}

export default Portrait
